import { Pipe, PipeTransform } from '@angular/core';
import { ChampLibre } from '../models/champLibre';

@Pipe({
  name: 'obsStatut',
  standalone: true
})
export class ObsStatutPipe implements PipeTransform {

  transform(obs?: ChampLibre, ...args: unknown[]): 'success' | 'warning' | 'error' | 'info' {
    return obs
      ? typeof obs.value == 'number' && (obs.value!) >= 4
        ? 'success'
        : 'error'
      : 'warning';
  }

}
